import { API_BASE_URL } from "../app_url";
import axios from "axios";

/**
 * Get authorization header for API requests
 * @returns {Object} Headers object with authorization token
 */
const getHeader = () => {
  let value = JSON.parse(localStorage.getItem("doctolikLoginInfo"));
  let header = {
    headers: {
      Authorization: "Bearer " + value.authorisation.token,
      'Cache-Control': 'no-cache',
    },
  };
  return header;
};

/**
 * Add a patient to a doctor's waiting room
 * @param {Object} values - Request payload
 * @param {number} values.roomId - The ID of the waiting room
 * @param {number} values.patient_id - The ID of the patient to add
 * @returns {Promise} Axios promise with response data
 */
export const pushPatientToWaitingRoomApi = (values) => {
  const { roomId, patient_id } = values;
  return axios.post(
    `${API_BASE_URL}doctor/waiting-rooms/${roomId}/patients`,
    { patient_id },
    getHeader()
  );
};

/**
 * Remove a patient from a doctor's waiting room
 * @param {Object} values - Request payload
 * @param {number} values.roomId - The ID of the waiting room
 * @param {number} values.patient_id - The ID of the patient to remove
 * @returns {Promise} Axios promise with response data
 */
export const removePatientFromWaitingRoomApi = (values) => {
  const { roomId, patient_id } = values;
  return axios.delete(
    `${API_BASE_URL}doctor/waiting-rooms/${roomId}/patients`,
    {
      ...getHeader(),
      data: { patient_id }
    }
  );
};

/**
 * Fetch all patients in a specific waiting room
 * @param {Object} values - Request payload
 * @param {number} values.roomId - The ID of the waiting room
 * @returns {Promise} Axios promise with response data containing patients array
 */
export const fetchWaitingRoomPatientsApi = (values) => {
  const { roomId } = values;
  return axios.get(
    `${API_BASE_URL}doctor/waiting-rooms/${roomId}/patients`,
    getHeader()
  );
};

/**
 * Get waiting room by doctor ID
 * Retrieves the waiting room for a specific doctor, including all patients
 * @param {Object} values - Request payload
 * @param {number} values.doctorId - The ID of the doctor
 * @returns {Promise} Axios promise with response data containing waiting room details and patients
 */
export const getWaitingRoomByDoctorApi = (values) => {
  const { doctorId } = values;
  return axios.get(
    `${API_BASE_URL}doctor/waiting-rooms/doctor/${doctorId}`,
    getHeader()
  );
};

/**
 * Get waiting room details
 * Retrieves detailed information about a specific waiting room
 * @param {Object} values - Request payload
 * @param {number} values.roomId - The ID of the waiting room
 * @returns {Promise} Axios promise with response data containing waiting room details
 */
export const getWaitingRoomDetailsApi = (values) => {
  const { roomId } = values;
  return axios.get(
    `${API_BASE_URL}doctor/waiting-rooms/${roomId}`,
    getHeader()
  );
};
